export default function formatMessageTime (content) {
    return {
        text: content
    }
}
